<script>
    import {createEventDispatcher} from 'svelte';
    import {format, addMonths, parse, startOfMonth} from 'date-fns';
    import {es} from 'date-fns/locale';
    import {fade} from 'svelte/transition';
    import ClickOutside from 'svelte-click-outside';

    import store from '../../Stores/calendario-store';
    import Mes from "../Calendario/Mes.svelte";
    import Navegacion from "./Navegacion.svelte";
    import Loading from "./Loading.svelte";

    const dispatch = createEventDispatcher();

    export let value;
    export let label;
    export let id;
    export let valido = true;
    export let mensajeDeError = "";
    export let icono = 'calendar_today';

    let fechaActual, mesActual, anioActual, valor, mes;
    $: fechaActual = value ? startOfMonth(value) : null;
    $: mesActual = fechaActual && fechaActual.getMonth();
    $: anioActual = fechaActual && fechaActual.getFullYear();
    $: anioActual && store.cargarDeEmpresa(anioActual);
    $: valor = value ? format(value, 'yyyy-MM-dd') : '';

    $: mes = $store.calendario ? $store.calendario.meses[mesActual] : {};

    let touched = false;
    let visible = false;
    let mostrar;

    const diaActualizado = e => {
        const fecha = parse(e.target.value, 'yyyy-MM-dd', new Date());
        if (!isNaN(fecha.getTime())) {
            dispatch('change', fecha);
        }
    };

    const clickEnDia = e => {
        dispatch('change', e.detail.fecha);
        visible = false;
    }
</script>

<style>
    .campo {
        border: 2px solid var(--bordes);
        border-radius: 3px 3px 0 0;
        display: flex;
    }

    .icono {
        flex: 0 0 auto;
        background: var(--bordes);
        display: flex;
        align-items: center;
        justify-content: center;
        color: var(--negro);
        padding: .25rem;
    }

    input {
        display: block;
        width: 100%;
        font: inherit;
        border: none;
        background: white;
        padding: 0.25em 0 .25em 1em;
        transition: border-color 0.1s ease-out;
    }

    input:focus {
        border-color: #e40763;
        outline: none;
    }

    label {
        display: block;
        margin-bottom: 0.5rem;
        width: 100%;
    }

    .form-control {
        padding: 0.5rem 0;
        width: 100%;
        margin: 0.25rem 0;
        position: relative;
    }

    .invalid {
        border-color: var(--acentos);
    }

    .invalid .icono {
        background: var(--acentos);
    }

    .error-message {
        color: red;
        margin: 0.25rem 0;
    }

    .calendario {
        position: absolute;
        background: #fff;
        z-index: 10;
        border: 2px solid var(--naranja-clarito);
        top: calc(100% - .5rem - 2px);
        min-width: 20em;
        box-shadow: 0 6px 6px -6px rgba(0, 0, 0, .3);
    }

    .navegacion {
        border-bottom: 1px solid var(--naranja-clarito);
        padding: calc(var(--padding-global) / 2);
    }

    .contenedor-mes {
        padding: calc(var(--padding-global) / 2);
    }

    .fecha {
        white-space: nowrap;
    }
</style>

<div class="form-control">
    <label for={id}>{label}</label>
    <div class="campo" class:invalid="{!valido && touched}">
        <div class="icono" on:click={() => visible = !visible} bind:this={mostrar}>
            <i class="material-icons">{icono}</i>
        </div>

        <input type="date" id={id} value={valor}
               on:change={diaActualizado}
               on:blur={() => touched = true}/>
    </div>
    {#if mensajeDeError && !valido && touched}
        <p class="error-message">{mensajeDeError}</p>
    {/if}

    {#if visible}
        <div transition:fade={{duration: 100}} class="calendario">
            <ClickOutside on:clickoutside={() => visible = false} exclude={[mostrar]}>
                <div class="navegacion">
                    <Navegacion on:cambio={e => fechaActual = addMonths(fechaActual, e.detail)}>
                        <div class="fecha">{format(fechaActual, 'MMMM yyyy', {locale: es})}</div>
                    </Navegacion>
                </div>

                <div class="contenedor-mes">
                    {#if mes}
                        <Mes calendario={mes} fecha={fechaActual} on:click-en-dia={clickEnDia}/>
                    {:else}
                        <Loading/>
                    {/if}
                </div>
            </ClickOutside>
        </div>
    {/if}
</div>
